import AdvancedCountrySelector from "@/Layouts/components/InputComponents/AdvancedCountrySelector";
import PhoneNumberTextField from "@/Layouts/components/InputComponents/PhoneNumberTextField";
import { TCountrySelected } from "@/Settings/types/SystemSettings/callActivity";
import { Box, Grid } from "@mui/material";
import Button from "@/Layouts/components/Buttons/Button";
import { useQueryClient } from "@tanstack/react-query";
import { AddCircleRounded } from "@mui/icons-material";

type TPhoneNumbersFormAreaProps = {
	locationId: string;
	disabled: boolean;
	numbers: string;
	countrySelected?: TCountrySelected | null;
	selectorPopperProps?: object;
	error?: boolean;
	onChangeCountry: (value: TCountrySelected) => void;
	clearNumbers: (value: string) => void;
	handleInputChange: (value: string, mask?: string) => void;
	onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;
	onAddButtonClick: () => void;
};

const PhoneNumbersFormArea = (props: TPhoneNumbersFormAreaProps) => {
	const {
		locationId,
		disabled,
		countrySelected,
		selectorPopperProps = undefined,
		numbers,
		onChangeCountry,
		clearNumbers,
		handleInputChange,
		onAddButtonClick,
		onKeyDown,
		error,
	} = props;
	const queryClient = useQueryClient();
	const { getFlags: flags } = queryClient.getQueryData(["systemSettingsAdditionalInfo", locationId]) as {
		getFlags: { abbr: string; code: string; icon: string; mask: string; name: string; _id: string }[];
	};

	const mappedFlags = flags?.map((flag) => {
		return {
			...flag,
			mask: flag?.mask?.replace(/#/g, "0"),
			image: (
				<Box>
					<span style={{ borderRadius: "3px" }} className={`fi fi-${flag.abbr.toLowerCase()}`}></span> <span>{flag.abbr}</span>
					<span style={{ marginLeft: "10px" }}>{flag.code}</span>
				</Box>
			),
			flagIcon: <span style={{ borderRadius: "3px" }} className={`fi fi-${flag.abbr.toLowerCase()}`}></span>,
		};
	});

	return (
		<Grid container spacing={2}>
			<Grid item>
				<AdvancedCountrySelector
					selectBy={"_id"}
					showBy={"name"}
					data={mappedFlags || []}
					selected={countrySelected}
					placeholder={"Country"}
					selectorPopperProps={selectorPopperProps}
					sx={{ width: "160px" }}
					disabled={disabled}
					countrySelected={countrySelected}
					onChange={onChangeCountry}
					onHandleChangeCountry={onChangeCountry}
					onChangeNumbers={clearNumbers}
				/>
			</Grid>
			<Grid item>
				<PhoneNumberTextField
					sx={{ width: "230px" }}
					value={numbers}
					editable
					specialCase={true}
					outlined
					disabled={disabled}
					placeholder={"Enter Phone Number/s"}
					error={error}
					onChange={(value: string) => handleInputChange(value, countrySelected?.mask)}
					onKeyDown={onKeyDown}
					handleKeyDownText={() => {}}
				/>
			</Grid>
			<Grid item>
				<Button
					variant="contained"
					text="Add"
					classes="btn-regular-add btn-small-height btn-regular-text"
					endIcon={<AddCircleRounded />}
					onClick={onAddButtonClick}
					sx={{ height: "30px", width: "120px" }}
					disabled={disabled || error}
				/>
			</Grid>
		</Grid>
	);
};

export default PhoneNumbersFormArea;
